<template>
  <div>
    <div class="prism-player" id="player-con"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: document.body.clientHeight
    }
  },
  methods: {
    videoPlay(src, height) {
      var player = new Aliplayer({
        "id": "player-con",
        "source": src,
        "width": "100%",
        "height": height,
        "autoplay": true,
        "isLive": true,
        "rePlay": false,
        "playsinline": true,
        "preload": true,
        "controlBarVisibility": "hover",
        "useH5Prism": true,
        "extraInfo": {
          "crossOrigin": "anonymous"
        },
        "skinLayout": [
          {
            "name": "bigPlayButton",
            "align": "blabs",
            "x": 30,
            "y": 80
          },
          {
            "name": "errorDisplay",
            "align": "tlabs",
            "x": 0,
            "y": 0
          },
          {
            "name": "infoDisplay"
          },
          {
            "name": "controlBar",
            "align": "blabs",
            "x": 0,
            "y": 0,
            "children": [
              {
                "name": "liveDisplay",
                "align": "tlabs",
                "x": 15,
                "y": 6
              },
              {
                "name": "fullScreenButton",
                "align": "tr",
                "x": 10,
                "y": 10
              },
              {
                "name": "subtitle",
                "align": "tr",
                "x": 15,
                "y": 12
              },
              {
                "name": "setting",
                "align": "tr",
                "x": 15,
                "y": 12
              },
              {
                "name": "volume",
                "align": "tr",
                "x": 5,
                "y": 10
              },
              {
                "name": "snapshot",
                "align": "tr",
                "x": 10,
                "y": 12
              }
            ]
          }
        ]
      }, function (player) {
        console.log("The player is created");
      });
      /* h5截图按钮, 截图成功回调 */
      player.on('snapshoted', function (data) {
        var pictureData = data.paramData.base64
        var downloadElement = document.createElement('a')
        downloadElement.setAttribute('href', pictureData)
        var fileName = 'Aliplayer' + Date.now() + '.png'
        downloadElement.setAttribute('download', fileName)
        downloadElement.click()
        pictureData = null
      })
    }
  },
  mounted() {
    this.videoPlay(this.$route.query.src, this.height+'px')
  }
}
</script>
<style lang="scss" scoped>
</style>